export const LeftOutlinedSVG = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.08321 13.4165C3.96785 13.4165 3.8551 13.3822 3.75919 13.3181C3.66329 13.254 3.58854 13.163 3.5444 13.0564C3.50026 12.9498 3.4887 12.8325 3.5112 12.7194C3.5337 12.6063 3.58924 12.5023 3.67079 12.4207L9.09171 6.99983L3.67079 1.57891C3.56453 1.4689 3.50574 1.32154 3.50707 1.1686C3.50839 1.01565 3.56974 0.869341 3.6779 0.761186C3.78605 0.653032 3.93236 0.591683 4.08531 0.590354C4.23826 0.589025 4.38561 0.647822 4.49563 0.754081L10.329 6.58741C10.4383 6.69681 10.4998 6.84515 10.4998 6.99983C10.4998 7.15451 10.4383 7.30286 10.329 7.41225L4.49563 13.2456C4.38625 13.355 4.23791 13.4165 4.08321 13.4165Z"
        fill="currentColor"
      />
    </svg>
  )
}
